export default {
	orders: {
		loading: "Bestellungen werden geladen...",
		noOrders: "Noch keine Bestellungen vorhanden",
		states: {
			ordered: "Bestellt",
			delivered: "Ausgeliefert",
			paid: "Abgeschlossen",
			inProduction: "In Produktion",
			produced: "In Spedition",
			invoiced: "Rechnung versendet",
			cancelled: "Storniert",
			creditOverdrawn: "Kreditlimit überschritten",
			unknown: "Unbekannt",
			dueDateLabel: "Lieferdatum ab Werk",
		},
		kommission: {
			placeholder: "Hier können Sie Ihre Auftragsnummer eintragen",
			placeholderShort: "Eintragen …",
			label: "Auftragsnummer",
			yourNumberLabel: "Ihre Auftragsnummer:",
			yourNumberShortLabel: "Ihre Auftragsnr.",
		},
		orderIdLabel: "Blexon-Auftrag",
		carrierLabel: "Transporteur",
		trackingLabel: "Sendungsverfolgung",
		orderConfirmation: {
			downloadTooltip: "Auftragsbestätigung als PDF-Dokument herunterladen",
			label: "Auftragsbestätigung",
			fileName: "Auftragsbestätigung {orderId}.pdf",
		},
		invoice: {
			downloadTooltip: "Rechnung als PDF-Dokument herunterladen",
			label: "Rechnung",
			fileName: "Rechnung zum Auftrag {orderId}.pdf",
		},
		prepayInvoice: {
			downloadTooltip: "Vorausrechnung als PDF-Dokument herunterladen",
			label: "Vorausrechnung",
			fileName: "Vorausrechnung {invoiceId}.pdf",
		},
		pageTitle: "Bestellarchiv",
		loadingArchive: "Bestellarchiv wird geladen …",
		searchPlaceholder: "Auftragsnr., Ihre Auftragsnr. oder Artikel-Id suchen …",
		filterAriaLabel: "Nach Typ filtern",
		filterAll: "Alle",
		filterOrders: "Bestellungen",
		filterCredits: "Gutschriften",
		noEntriesFound: "Keine Einträge gefunden",
		noCreditsYet: "Noch keine Gutschriften vorhanden",
		adjustSearchHint: "Passen Sie Suche oder Filter an.",
		creditPillTooltip:
			"Summe Ihrer offenen Gutschriften. Wird automatisch mit der nächsten Rechnung verrechnet.",
		availableCredit: "Verfügbares Guthaben",
		thumbsTooltip: "Artikel dieser Bestellung",
		articleCountSuffix: "Artikel",
		detailsButton: "Details",
		orderTypeTag: "Bestellung",
		orderTitle: "Bestellung {number} vom {date}",
		certificatesSuffix: " / Zertifikate",
		creditNote: {
			typeTag: "Gutschrift",
			unassignedChip: "Ohne Bestellbezug",
			stateRefunded: "Rückerstattet",
			stateSettled: "Verrechnet",
			stateOpen: "Offen",
			unassignedNote:
				"Diese Gutschrift gehört zu keiner Bestellung und wird mit Ihrer nächsten Rechnung verrechnet.",
			settledNextInvoiceNote: "Wird mit Ihrer nächsten Rechnung verrechnet.",
			numberLabel: "Gutschrift-Nr.",
			dateLabel: "Datum",
			referenceLabel: "Bezug",
			referenceOrder: "Auftrag {orderId}",
			noReference: "Keine Bestellung",
			settledOnLabel: "Verrechnet auf",
			invoiceReference: "Rechnung {invoiceId}",
			downloadTooltip: "Gutschrift als PDF-Dokument herunterladen",
			downloadButton: "Gutschrift",
			fileName: "Gutschrift {creditNoteId}.pdf",
		},
		details: "Details",
		detailsWithCertificates: "Details / Zertifikate",
		cancellation: {
			inReview: "Stornierung in Abklärung",
			show: "Stornierung anzeigen",
			completed: "Stornierung abgeschlossen",
			processing: "Stornierung wird verarbeitet",
			cancelButton: "Stornieren",
			orderCancelledSuccess: "Der Auftrag wurde erfolgreich storniert.",
			orderAlreadyProcessed: "Der Auftrag wurde inzwischen verarbeitet.",
			cancelFailed: "Auftrag konnte nicht storniert werden.",
		},
		changeDeliveryAddress: "Lieferadresse ändern",
		changeInvoiceAddress: "Rechnungsadresse ändern",
		loadMore: {
			tooltip: "Lädt weitere Bestellungen.",
			button: "Mehr laden",
		},
		confirmCancellationDialog: {
			title: "Stornierung bestätigen",
			text: "Die Bearbeitung für diesen Auftrag wurde noch nicht gestartet.",
			text2: "Eine Stornierung ist in diesem Fall kostenlos möglich. Dabei kann jedoch nur der ganze Auftrag storniert werden. Bei Bedarf muss die Bestellung neu aufgegeben werden.",
			cancelButton: "Abbrechen",
			confirmButton: "Stornieren",
		},
		messages: {
			kommissionSaved: "Auftragsnummer wurde gespeichert.",
			kommissionSaveError: "Fehler beim Speichern der Auftragsnummer.",
		},
	},
	orderDetail: {
		backToOrders: "Bestellarchiv",
		orderHeading: "Auftrag {orderId}",
		certificatesAvailable: {
			title: "Zertifikate verfügbar",
			subtitle: "Werkszeugnisse 3.1 zu diesem Auftrag herunterladen.",
			button: "Zertifikat 3.1 · Artikel {articleId}",
		},
		orderDataTitle: "Auftragsdaten",
		orderReceivedLabel: "Auftragseingang",
		yourOrderNumberShortLabel: "Ihre Auftragsnummer",
		noOrderNumberShort: "keine Angabe",
		expectedDeliveryDateShortLabel: "Voraussichtlicher Liefertermin (ab Werk)",
		expectedCompletionShortLabel: "Voraussichtliche Fertigstellung",
		trackingLabelShort: "Sendungsverfolgung",
		invoiceAddressCardTitle: "Rechnungsadresse",
		positionsCardTitle: "Positionen",
		tableShort: {
			posAbbr: "Pos.",
			totalAbbr: "Gesamt ({currency})",
		},
		titleLabel: "Bestätigung zu Auftrag {orderId}",
		orderDateLabel: "Auftragseingang:",
		yourOrderNumberLabel: "Ihre Auftragsnummer:",
		noOrderNumber: "keine Angabe (Sie können diese im Bestellarchiv anpassen)",
		expectedDeliveryDateLabel: "Voraussichtlicher Liefertermin (ab Werk):",
		trackingEmailInfo:
			"Nach Fertigstellung des Auftrags erhalten Sie eine E-Mail mit einem Link zur Sendungsverfolgung.",
		expectedCompletionLabel: "Voraussichtliche Fertigstellung:",
		pickupImportantLabel: "Wichtig:",
		pickupEmailInfo:
			"Sie erhalten eine E-Mail sobald Ihr Auftrag bereit zur Abholung ist. Die Abholung ist erst möglich, nachdem Sie diese E-Mail erhalten haben.",
		invoiceAddressLabel: "Rechnungsadresse:",
		pickupAddressLabel: "Abholadresse",
		deliveryAddressLabel: "Lieferadresse",
		pickupAddressName: "Abholung",
		priceModel: {
			standard: "(Schnelle Lieferung)",
			slow: "(Preisoptimale Lieferung)",
			express: "(Express Lieferung)",
		},
		table: {
			position: "Position",
			quantity: "Menge",
			preview: "Vorschau",
			description: "Beschreibung",
			pricePerUnit: "Preis/Stk",
			totalPrice: "Gesamtpreis ({currency})",
		},
		engraving: "Gravur",
		deburring: "Entgraten:",
		preCoated: "vorgrundiert",
		certificateLink: "Zertifikat 3.1",
		vatLabel: "MwSt ({rate}%)",
		totalLabel: "Total",
		certificateErrorDialog: {
			title: "Zertifikat kann nicht geladen werden",
			text: "Das Zertifikat kann aktuell nicht geladen werden. Der Dienst scheint nicht verfügbar.",
			text2: "Bitte wenden Sie sich an unser Helpdesk.",
			closeButton: "Schliessen",
		},
	},
	ticket: {
		tooltip: "Öffnet den Dialog zum Ausfüllen einer Beanstandung zu dieser Bestellung.",
		deadlinePassedTooltip: "Die Frist für eine Beanstandung ist abgelaufen. Bitte wenden Sie sich an das Helpdesk.",
		createButton: "Beanstandung erfassen",
		showButton: "Beanstandung anzeigen",
	},
	editTicketPosition: {
		blexonIdLabel: "Blexon Id:",
		materialLabel: "Material:",
		preCoated: "vorgrundiert",
		engraving: "Gravur",
		introText:
			"Damit wir Ihre Beanstandung schnell und unkompliziert bearbeiten können, brauchen wir zu jeder Position einige Angaben.",
		complainTypeQuestion: "Welcher Art ist ihre Beanstandung?",
		selectPlaceholder: "Bitte auswählen",
		uploadPhotosQuestion: "Laden Sie Fotos hoch, welche die Beanstandung möglichst klar zeigen",
		deleteImageTooltip: "Bild löschen",
		minOneImageHint: "Mindestens ein Bild muss hochgeladen werden.",
		affectedPartsQuestion: "Wie viele Teile dieser Position sind betroffen?",
		allButton: "Alle",
		partsCountLabel: "Anzahl Teile",
		complaintDescriptionQuestion: "Was beanstanden Sie?",
		complaintDescriptionLabel: "Beanstandung",
		expectationQuestion: "Was erwarten Sie von uns?",
		expectationLabel: "Erwartung",
		messages: {
			requiredField: "Muss angegeben werden.",
			enterValue: "Wert angeben",
			minimumOne: "Mindestens 1",
			maximum: "Maximal {max}",
			maxImagesExceeded: "Sie können maximal 10 Bilder hochladen.",
			imageUploadError:
				"Bild kann nicht gelesen werden. Bitte verwenden Sie ein Bild im Format jpg, png oder gif. Bei Problemen wenden Sie sich bitte an info@blexon.com.",
		},
	},
	requestCancellation: {
		orderNotFound: "Der Auftrag konnte nicht gefunden werden.",
		titleLabel: "Stornierung für Auftrag #{orderId} beantragen",
		alreadyProcessedWarning: "Leider hat die Verarbeitung des Auftrags inzwischen begonnen.",
		introText:
			"Dieser Auftrag wird bereits bearbeitet. Eine Stornierung kann aber trotzdem beantragt werden.",
		introText2:
			"Wir klären die bereits entstandenen Kosten ab und kontaktieren Sie per E-Mail. Sie entscheiden dann, welche Positionen des Auftrags Sie definitiv stornieren möchten.",
		feeNoticePart1:
			"Selbst wenn nach der Kostenabklärung auf die Stornierung verzichtet wird, ist eine Bearbeitungsgebühr von",
		feeNoticePart2: "fällig, sobald Sie eine Stornierung beantragen.",
		selectArticlesText: "Bitte selektieren Sie die zu stornierenden Artikel:",
		table: {
			position: "Position",
			quantity: "Menge",
			preview: "Vorschau",
			description: "Beschreibung",
			pricePerUnit: "Preis / Stk",
			priceTotal: "Preis Total",
		},
		blexonIdLabel: "Blexon Id:",
		acceptCostsLabel:
			"Ich akzeptiere die pauschale Bearbeitungsgebühr von {currency} {fixCost}.-, welche bei der Beantragung der Stornierung anfällt.",
		forceCancellationLabel:
			"OPTIONAL! Ich möchte die ausgewählten Positionen, unabhängig von den entstandenen Kosten, definitiv stornieren. Ich bestätige, alle Stornierungskosten für die Positionen und die Stornierungspauschale zu übernehmen und auf die Teile zu verzichten.",
		contactInfoText1: "Wir informieren Sie bezüglich dieser Stornierung unter der Adresse",
		contactInfoText2:
			"Falls Sie über eine andere E-Mail Adresse kontaktiert werden möchten, können Sie diese hier angeben:",
		altContactEmailLabel: "Alternative E-Mail Adresse",
		cancelButton: "Abbrechen",
		forceCancelButton: "Definitiv stornieren",
		requestCancelButton: "Stornierung beantragen",
		altContactButton: {
			useStandard: "Standard Kontaktdaten verwenden",
			useAlternative: "Alternative Kontaktdaten verwenden",
		},
		messages: {
			fixCostLoadError: "Stornierungspauschale konnte nicht geladen werden.",
			positionsLoadError: "Auftragspositionen konnten nicht geladen werden.",
			cancellationRequested: "Stornierung wurde beantragt.",
			cancellationRequestError: "Stornierung konnte nicht beantragt werden.",
			requiredField: "Muss angegeben werden.",
			invalidEmail: "Keine gültige Email.",
		},
	},
	cancellationConfirmation: {
		requestNotFound: "Der Stornierungsantrag konnte nicht gefunden werden.",
		alreadyProcessed: "Dieser Stornierungsantrag wurde bereits bearbeitet.",
		titleLabel: "Stornierung für Auftrag #{orderId} bestätigen",
		introText: "Sie haben beantragt, gewisse Positionen dieser Bestellung zu stornieren.",
		introText2:
			"Die Kosten für die Stornierung sind unten pro Position aufgelistet. Sie können die Positionen auswählen, die sie stornieren möchten. Die Kosten werden entsprechend angepasst. Nicht stornierte Positionen werden normal weiterverarbeitet. Die Stornierungspauschale für die getätigten Abklärungen im Zusammenhang mit der Stornierung ist in jedem Fall fällig und ist in den Kosten enthalten.",
		table: {
			articleId: "Artikel Id",
			position: "Position",
			preview: "Vorschau",
			description: "Beschreibung",
			cancellationCost: "Stornierungskosten",
		},
		flatFeeLabel: "Stornierungspauschale",
		totalLabel: "Total",
		backButton: "Zurück",
		doNotCancelButton: "Nicht stornieren",
		cancelSelectedButton: "Ausgewählte Positionen stornieren",
		messages: {
			loadCancellationError: "Stornierungsdaten konnten nicht geladen werden.",
			loadOrderError: "Auftragsdaten konnten nicht geladen werden.",
			confirmError: "Stornierung konnte nicht bestätigt werden.",
		},
	},
	choosePosition: {
		introText: "Bitte wählen Sie alle Positionen aus, welche von dieser Meldung betroffen sind.",
		table: {
			position: "Position",
			image: "Bild",
			description: "Beschreibung",
			quantity: "Menge",
			unitPrice: "Stückpreis",
			total: "Total",
		},
		blexonIdLabel: "Blexon Id:",
		materialLabel: "Material:",
		preCoated: "vorgrundiert",
		engraving: "Gravur",
	},
	createTicket: {
		titleLabel: "Beanstandung zu Auftrag {orderId}",
		stepper: {
			choosePositions: "Positionen auswählen",
			positionAbbrev: "Pos",
			position: "Position",
			contactData: "Kontaktdaten",
			confirmation: "Bestätigung",
		},
		emailNoticePart1: "Wir senden Ihnen eine E-Mail an",
		emailNoticePart2: ", sobald sich der Status dieser Beanstandung ändert. Bei Rückfragen rufen wir Sie unter",
		emailNoticePart3: " an.",
		altContactPrompt:
			"Falls Sie für die Bearbeitung dieser Beanstandung anders kontaktiert werden möchten, können Sie alternative Kontaktdaten angeben:",
		altContactEmailLabel: "Alternative E-Mail Adresse",
		altContactPhoneLabel: "Alternative Telefonnummer",
		altContactButton: {
			useStandard: "Standard Kontaktdaten verwenden",
			useAlternative: "Alternative Kontaktdaten verwenden",
		},
		missingInfoText: "Bitte ergänzen Sie die fehlenden Angaben, um das Ticket zu erstellen.",
		table: {
			position: "Position",
			image: "Bild",
			blexonId: "Blexon Id",
			complainedCount: "# Beanstandete",
			name: "Name",
			complaint: "Beanstandung",
			expectation: "Erwartung",
		},
		correspondenceToLabel: "Korrespondenz an:",
		replacementDelivery: "Ersatzlieferung",
		backButton: "Zurück",
		nextButton: "Weiter",
		finishButton: "Abschliessen",
		ticketBlockedHint:
			"Die Beanstandung ist bereits verarbeitet. Wenden Sie sich an info@blexon.com für weitere Unterstützung.",
		leaveDialog: {
			title: "Datenverlust Warnung",
			text: "Änderungen werden beim Verlassen verworfen.",
		},
		messages: {
			requiredField: "Muss angegeben werden.",
			invalidEmail: "Keine gültige Email.",
			saveSuccess: "Beanstandung wurde erfolgreich gespeichert.",
			saveError: "Fehler beim Speichern. Bitte wenden Sie sich an info@blexon.com.",
			orderNotFound: "Ticket kann nicht erstellt werden. Auftrag nicht gefunden.",
		},
	},
};
